import React from 'react';
import { Script, ScriptStrategy } from 'gatsby';
import { isProd } from '@agria/utils'; // Assuming this utility is correctly imported

const LOAD_SURFLY = process.env.GATSBY_LOAD_SURFLY === 'true';
const LOAD_LIVE_CHAT = process.env.GATSBY_LOAD_LIVE_CHAT === 'true';

export const ScriptsBefore = () => {
  // Get the list of paths where live chat should be disabled
  const LIVE_CHAT_DISABLED_PATHS =
    process.env.GATSBY_LIVE_CHAT_DISABLED_PATHS || '';

  return (
    <>
      {/* GTM */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
  
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PK9D66');
      `}
      </Script>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-PK9D66"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="gtm-frame"
        />
      </noscript>

      {/* OneTrust Cookies Consent Notice */}
      <Script
        strategy={ScriptStrategy.postHydrate}
        type="text/javascript"
        src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
        charSet="UTF-8"
        data-domain-script={`6838ac24-c4a1-49da-814b-86be451dcdeb${
          !isProd ? '-test' : ''
        }`}
      />
      <Script
        strategy={ScriptStrategy.postHydrate}
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: 'function OptanonWrapper() {}' }}
      />

      {/* TVSquared Tracking Code */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
        var _tvqsky = window._tvqsky = window._tvqsky || [];
        (function() {
        var u = (("https:" == document.location.protocol) ?
        "https://collector-31509.tvsquared.com/"
        :
        "http://collector-31509.tvsquared.com/");
        _tvqsky.push(['setSiteId', "TV-6381459009-1"]);
        _tvqsky.push(['setTrackerUrl', u + 'tv2track.php']);
        _tvqsky.push([function() {
        this.deleteCustomVariable(5, 'page')
        }]);
        _tvqsky.push(['trackPageView']);
        var d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
        g.type = 'text/javascript';
        g.defer = true;
        g.async = true;
        g.src = u + 'tv2tracksky.js';
        s.parentNode.insertBefore(g, s);
        })();
      `}
      </Script>

      {/* TV tracking (Adalyser) */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
        (function(clientId) {
          if(window["__adal_disable_" + clientId]) { return; }
          (function(windowAlias, documentAlias, trackerName) {
              if (!windowAlias[trackerName]) {
                  windowAlias.GlobalAdalyserNamespace = windowAlias.GlobalAdalyserNamespace
                          || [];
                  windowAlias.GlobalAdalyserNamespace.push(trackerName);
                  windowAlias[trackerName] = function() {
                      (windowAlias[trackerName].q = windowAlias[trackerName].q || []).push(arguments)
                  };
                  windowAlias[trackerName].q = windowAlias[trackerName].q || [];
                  var nel = documentAlias.createElement("script"),
                      fel = documentAlias.getElementsByTagName("script")[0];
                  nel.async = 1;
                  nel.src = "//c5.adalyser.com/adalyser.js?cid=" + clientId;
                  fel.parentNode.insertBefore(nel, fel)
              }
          }(window, document, "adalyserTracker"));
          window.adalyserTracker("create", {
              campaignCookieTimeout: 15552000,
              conversionCookieTimeout: 604800,
              clientId: clientId,
              trafficSourceInternalReferrers: [
                  "^(.*\\.)?agriapet\\.co\\.uk$"
              ]
          });
          window.adalyserTracker("trackSession", "lce1");
      })("agriapetinsurance");
      `}
      </Script>

      {/* Dax radio tracking */}
      <img
        src="https://tracking.audio.thisisdax.com/one.png?client=AgriaPets&action=cs&eventId=&event=JourneyAppe&j=0"
        width="0"
        height="0"
        style={{ display: 'none' }}
        alt=""
      />

      {/* Optimise */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
       OMID=1152041;OPID=32478;ORef=escape(window.parent.location.href);
       !function(){var a=document.createElement("script");a.type="text/javascript",a.async=!0,
       a.src="//track.omguk.com/e/qs/?action=Content&MID=" + OMID + "&PID=" + OPID + "&ref="+ ORef;
       var b=document.getElementsByTagName("body")[0];if(b)b.appendChild(a,b);
       else{var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)}}();
      `}
      </Script>

      {/* Pixel (AppNexus) */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
       !function(e,i){if(!e.pixie){var n=e.pixie=function(e,i,a){n.actionQueue.push({action:e,actionValue:i,params:a})};n.actionQueue=[];var a=i.createElement("script");a.async=!0,a.src="//acdn.adnxs.com/dmp/up/pixie.js";var t=i.getElementsByTagName("head")[0];t.insertBefore(a,t.firstChild)}}(window,document);
       pixie('init', '4d07860b-0dfc-41a7-8244-3cebd93c414f');
      `}
      </Script>

      {/* Bing Ads */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
       (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[] ,f=function(){var o={ti:"17219122"}; o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")} ,n=d.createElement(t),n.src=r,n.async=1,n.onload=n .onreadystatechange=function() {var s=this.readyState;s &&s!=="loaded"&& s!=="complete"||(f(),n.onload=n. onreadystatechange=null)},i= d.getElementsByTagName(t)[0],i. parentNode.insertBefore(n,i)})(window,document,"script"," //bat.bing.com/bat.js","uetq");
      `}
      </Script>

      {/* Yieldify */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
       (function(d){var e=d.createElement('script');e.src='https://td.yieldify.com/yieldify/code.js?w_uuid=a0bdcf52-49eb-4cfc-91a6-719c66e05ec0&k=1&loca='+encodeURIComponent(window.location.href);e.async=true;d.getElementsByTagName('head')[0].appendChild(e);}(document)); /* Added encodeURIComponent */
      `}
      </Script>

      {/* Smarter tracking */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`
          (function (s, m, a, r, t) { s[r] = s[r] || []; var f = m.getElementsByTagName(a)[0], j = m.createElement(a), dl = r != 'dataLayer' ? '&r=' + r : ''; j.async = true; j.src = '//smct.co/tm/?t=' + t + dl; f.parentNode.insertBefore(j, f); }
          )(window, document, 'script', 'dataLayer', 'agriapet.co.uk');
       `}
      </Script>

      {/* Surfly Script Integration */}
      {LOAD_SURFLY && (
        <>
          <Script
            src="https://surfly.com/surfly.js"
            strategy={ScriptStrategy.postHydrate}
            id="surfly-sdk"
            onLoad={() => {
              // This flag indicates the external Surfly script file itself has loaded.
              // It's used by the initialization logic below.
              if (!window.surflySDKLoaded) {
                window.surflySDKLoaded = true;
              }
            }}
            onError={() => {
              // Handle cases where the script itself fails to load (e.g., network error, 404)
              console.error(
                'Surfly SDK script file failed to load (onError triggered).'
              );
              window.surflySDKLoaded = false; // Indicate failure if needed
            }}
          />
          <Script strategy={ScriptStrategy.idle} id="surfly-init-logic">
            {`
            (function() {
              // Ensure this entire initialization block runs only once
              if (window.surflyInitialized) {
                return;
              }
              window.surflyInitialized = true;

              const WIDGET_KEY = "${
                process.env.GATSBY_SURFLY_WIDGET_KEY || ''
              }";
              let currentSurflySession = null;

              function initSurfly() {
                if (!WIDGET_KEY) {
                  console.error('Surfly Widget Key (GATSBY_SURFLY_WIDGET_KEY) is not configured. Surfly will not initialize.');
                  return;
                }

                // This check is now more robust in checkAndInit, but a defensive check here is still okay.
                if (typeof window.Surfly === 'undefined' || typeof window.Surfly.init !== 'function') {
                  console.error('Surfly SDK (window.Surfly or window.Surfly.init) not available when initSurfly was called. This should have been caught by checkAndInit.');
                  return;
                }
                
                const surflySettings = {
                  widget_key: WIDGET_KEY,
                  block_until_agent_joins: false, 
                  hide_until_agent_joins: true,  
                  session_start_confirmation: false,
                  // MODIFICATION 1: Added on_error to surflySettings
                  on_error: function(errorData) {
                      console.error('Surfly SDK reported an error via settings.on_error:', errorData);
                  }
                };

                try {
                  window.Surfly.init(surflySettings, function(init) {
                    if (init.success) {
                      if (window.Surfly.isInsideSession) {
                        // Potentially sync currentSurflySession if needed
                        // currentSurflySession = window.Surfly.currentSession;
                        return;
                      }

                      window.startSurflySession = function(pinCallback, sessionEndCallback, errorCallback) { // Added errorCallback for consistency, though old logic might not use it fully
                        if (currentSurflySession) {
                          console.warn('Surfly: Session is already active or being started.');
                          if (currentSurflySession.pin && typeof pinCallback === 'function') {
                            pinCallback(currentSurflySession.pin);
                          }
                          return;
                        }
                        
                        try {
                          currentSurflySession = window.Surfly.session({}); // Pass session-specific settings here if any

                          currentSurflySession.on("session_created", function(sessionInfo, event) {
                            if (typeof pinCallback === 'function') {
                              pinCallback(sessionInfo.pin);
                            }
                          });

                          currentSurflySession.on("session_ended", function(sessionInfo, event) {
                            currentSurflySession = null;
                            if (typeof sessionEndCallback === 'function') {
                              sessionEndCallback();
                            }
                          });

                          currentSurflySession.on("error", function(sessionObj, eventError) { // Parameters might be (session, error) or just (error) depending on event
                            console.error('Surfly event: Session error:', eventError, 'Session obj:', sessionObj);
                            currentSurflySession = null; 
                            // Use the new errorCallback if provided
                            if (typeof errorCallback === 'function') {
                              errorCallback(eventError);
                            } else if (typeof sessionEndCallback === 'function') { 
                              // Fallback to old behavior if no specific error callback
                              sessionEndCallback();
                            }
                          });

                          currentSurflySession.startLeader();
                        } catch (sessionError) {
                          console.error('Surfly: Error creating or starting Surfly session:', sessionError);
                          currentSurflySession = null;
                          if (typeof errorCallback === 'function') {
                            errorCallback(sessionError);
                          } else if (typeof sessionEndCallback === 'function') {
                            sessionEndCallback();
                          }
                        }
                      };

                      window.endSurflySession = function() {
                        if (currentSurflySession) {
                          try {
                            currentSurflySession.end();
                            // currentSurflySession will be nulled by 'session_ended' event
                          } catch (endError) {
                            console.error('Surfly: Error calling currentSurflySession.end():', endError);
                            currentSurflySession = null; // Ensure cleanup
                          }
                        } else {
                        }
                      };

                    } else {
                      console.error('Surfly: Initialization failed (Surfly.init callback). Error:', init.error || 'Unknown error', 'Full init object:', init);
                    }
                  });
                  
                  // Fallback timeout in case the Surfly.init callback never fires or startSurflySession isn't defined
                  setTimeout(function() {
                    if (typeof window.startSurflySession === 'undefined') {
                      console.warn('Surfly: Init callback may not have fired or defined startSurflySession within 3 seconds. Defining fallback/stub functions.');
                      
                      window.startSurflySession = function(pinCallback, sessionEndCallback, errorCallback) {
                        console.error('Surfly: Fallback startSurflySession - Surfly initialization likely failed or timed out, session cannot be started.');
                        if (typeof errorCallback === 'function') {
                          errorCallback(new Error('Surfly init fallback timeout'));
                        } else if (typeof sessionEndCallback === 'function') {
                          sessionEndCallback();
                        }
                      };

                      window.endSurflySession = function() {
                        console.error('Surfly: Fallback endSurflySession - Surfly not properly initialized.');
                      };
                    }
                  }, 3000); // 3 seconds
                  
                } catch (initError) {
                  console.error('Surfly: Critical error during window.Surfly.init() call:', initError);
                }
              }
              
              // Polling function to wait for Surfly SDK to be available
              let attempts = 0;
              const maxAttempts = 10; // Try for 5 seconds (10 attempts * 500ms interval)
              const interval = 500;   // ms

              function checkAndInit() {
                attempts++;
                // MODIFICATION 2: Enhanced the condition to check for Surfly.init function
                if (window.surflySDKLoaded && typeof window.Surfly !== 'undefined' && typeof window.Surfly.init === 'function') {
                  initSurfly();
                } else if (attempts < maxAttempts) {
                  setTimeout(checkAndInit, interval);
                } else {
                  console.error(\`Surfly: Timeout. SDK did not load or Surfly.init not available after \${(maxAttempts * interval / 1000)} seconds (\${attempts} attempts). Surfly will not be initialized. SDKLoaded: \${!!window.surflySDKLoaded}, SurflyObject: \${typeof window.Surfly}, SurflyInit: \${typeof window.Surfly === 'object' && window.Surfly ? typeof window.Surfly.init : 'N/A'}\`);
                  // Define stubs if timeout occurs before init, to prevent errors if called
                  if (typeof window.startSurflySession === 'undefined') {
                    window.startSurflySession = function(pinCb, endCb, errCb) { console.error('Surfly: startSurflySession (stub) - SDK did not initialize.'); if(typeof errCb === 'function') errCb(new Error('Surfly SDK init timeout')); else if(typeof endCb === 'function') endCb();};
                    window.endSurflySession = function() { console.error('Surfly: endSurflySession (stub) - SDK did not initialize.'); };
                  }
                }
              }
              
              // Start the check. It relies on window.surflySDKLoaded being set by the <Script onLoad>
              checkAndInit();

            })();
          `}
          </Script>
        </>
      )}

      {/* Livechat (CXone) Integration */}
      {LOAD_LIVE_CHAT && (
        <Script
          strategy={ScriptStrategy.postHydrate}
          id="cxone-init-and-cobrowse-trigger"
        >
          {`
              // Check if live chat should be disabled for current path
              function shouldDisableLiveChatForCurrentPath() {
                const disabledPaths = '${LIVE_CHAT_DISABLED_PATHS}';
                
                if (!disabledPaths) {
                  return false;
                }
                
                const currentPath = window.location.pathname;
                const paths = disabledPaths.split(',').map(path => path.trim());
                
                return paths.some(disabledPath => {
                  if (disabledPath.endsWith('*')) {
                    return currentPath.startsWith(disabledPath.slice(0, -1));
                  }
                  return currentPath === disabledPath;
                });
              }

              // Function to show/hide chat using CSS
              function toggleChatVisibility() {
                const shouldHide = shouldDisableLiveChatForCurrentPath();
                
                // Get or create the style element
                let styleEl = document.getElementById('live-chat-visibility-style');
                if (!styleEl) {
                  styleEl = document.createElement('style');
                  styleEl.id = 'live-chat-visibility-style';
                  document.head.appendChild(styleEl);
                }
                
                if (shouldHide) {
                  styleEl.textContent = '#be-chat-container { display: none !important; }';
                } else {
                  styleEl.textContent = '#be-chat-container { display: block !important; }';
                }
              }

              // Initial visibility check
              toggleChatVisibility();

              // Ensure this CXone initialization and event listener setup runs only once
              if (!window.cxoneGlobalSetupStarted) {
                window.cxoneGlobalSetupStarted = true;

                // 1. CXone Loader
                (function(n, u) {
                  window.CXoneDfo = n;
                  window[n] = window[n] || function() {
                    (window[n].q = window[n].q || []).push(arguments);
                  };
                  window[n].u = u;
                  
                  var loaderScriptId = 'cxone-loader-script';
                  if (!document.getElementById(loaderScriptId)) {
                    var e = document.createElement("script");
                    e.id = loaderScriptId;
                    e.type = "module";
                    e.src = u + "?" + Math.round(Date.now() / 1e3 / 3600); // Cache-busting
                    document.head.appendChild(e);
                  }
                })('cxone', 'https://web-modules-de-uk1.niceincontact.com/loader/1/loader.js');

                // 2. Queue CXone Initialization Commands & Setup Cobrowse Listener
                function setupCxOneInteractions() {
                  try {
                    // Queue CXone initialization commands
                    cxone('init', '1332');
                    cxone('chat', 'init', 1332, 'chat_1c365a59-2701-4e39-bab9-bfb996282be0');
                    // Allow specific message types, crucial for receiving the #COBRO# message
                    cxone('chat', 'setAllowedExternalMessageTypes', ['MESSAGE_SENT', 'MESSAGE_RECEIVED']);

                    // 3. Add Cobrowse Trigger Event Listener (if not already added)
                    if (!window.cxoneCobrowseMessageListenerAdded) {
                      window.addEventListener("message", function(event) {
                        // Basic validation of the event structure
                        if (event.data && 
                            event.data.actionType === "MESSAGE_RECEIVED" && 
                            event.data.action && 
                            typeof event.data.action.message === 'string') {
                          
                          const messageContent = event.data.action.message;
                          
                          if (messageContent.trim() === "#COBRO#") {
                            
                            if (typeof window.startSurflySession === 'function') {
                              // Call the globally available Surfly session starter function
                              window.startSurflySession(
                                function(pin) { // pinCallback
                                  // TODO: Implement sending PIN back to chat agent if needed and CXone supports it.
                                  // Example: cxone('chat', 'sendMessage', 'Your Surfly Co-browse PIN is: ' + pin);
                                },
                                function() { // sessionEndCallback
                                },
                                function(error) { // errorCallback
                                  console.error("CXone Live Chat via Surfly: Error during Surfly session:", error);
                                }
                              );
                            } else {
                              console.warn("CXone Live Chat: Surfly function 'window.startSurflySession' not found. CoBrowse cannot be initiated. Ensure Surfly script (if used) is loaded and initialized correctly.");
                            }
                          }
                        }
                      });
                      window.cxoneCobrowseMessageListenerAdded = true;
                    }
                  } catch (error) {
                    console.error('CXone Live Chat: Error during setupCxOneInteractions:', error);
                  }
                }

                // The CXone loader pattern queues commands if 'cxone' isn't ready.
                setupCxOneInteractions();

                // Set up route change listener for SPA navigation
                let lastUrl = location.href;
                new MutationObserver(() => {
                  const url = location.href;
                  if (url !== lastUrl) {
                    lastUrl = url;
                    // Wait a bit for the page to settle, then toggle visibility
                    setTimeout(toggleChatVisibility, 100);
                  }
                }).observe(document, { subtree: true, childList: true });

                // Also listen for popstate events (back/forward navigation)
                window.addEventListener('popstate', function() {
                  setTimeout(toggleChatVisibility, 100);
                });
              }
            `}
        </Script>
      )}
    </>
  );
};
